
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/items/[[...slug]]",
      function () {
        return require("private-next-pages/items/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/items/[[...slug]]"])
      });
    }
  